import {Component, OnInit} from '@angular/core';
import {NotifierService} from "angular-notifier";
import {ServiceService} from "../../../service.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import * as XLSX from 'xlsx';

// This is for the range date picker
const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one &&
  two &&
  two.year === one.year &&
  two.month === one.month &&
  two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two
    ? false
    : one.year === two.year
    ? one.month === two.month
      ? one.day === two.day
        ? false
        : one.day < two.day
      : one.month < two.month
    : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two
    ? false
    : one.year === two.year
    ? one.month === two.month
      ? one.day === two.day
        ? false
        : one.day > two.day
      : one.month > two.month
    : one.year > two.year;

// End  range date picker

@Component({
  selector: 'app-category-manager',
  templateUrl: './category-manager.component.html',
  styleUrls: ['./category-manager.component.css']
})
export class CategoryManagerComponent implements OnInit {
  allCategories: any[];
  private notifier: NotifierService;
  id: any;
  image_url: any;
  subtitle: any;
  subtitle_sinhala: any;
  title: any;
  title_sinhala: any;
  createStatus = true;

  constructor(private serviceClass: ServiceService, private activatedRoute: ActivatedRoute, private router: Router, notifier: NotifierService) {
    this.notifier = notifier;
  }

  ngOnInit(): void {
    window.scroll(0, 0);
    this.serviceClass.getCategoryAllType().subscribe(
      data => {
        this.allCategories = data;
      }
    );
  }

  addCategories = () => {
    this.serviceClass.addCategory(this.image_url, this.subtitle, this.subtitle_sinhala, this.title, this.title_sinhala).subscribe(
      data => {
        this.serviceClass.getCategoryAllType().subscribe(
          data => {
            this.allCategories = data;
            this.showNotification("success","Category added successfully!");
          }
        );
      }
    );
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }

  editCategories(id: any, title: any, title_sinhala: any, subtitle: any, subtitle_sinhala: any, image_url: any) {
    window.scroll(0, 0);
    this.createStatus = false;
    this.id = id;
    this.title = title;
    this.title_sinhala = title_sinhala;
    this.subtitle = subtitle;
    this.subtitle_sinhala = subtitle_sinhala;
    this.image_url = image_url;
  }

  cancelCategories() {
    this.createStatus = true;
    this.id = 0;
    this.title = "";
    this.title_sinhala = "";
    this.subtitle = "";
    this.subtitle_sinhala = "";
    this.image_url = "";
  }

  updateEditCategories(){
    this.serviceClass.updateCategory(this.id,this.image_url, this.subtitle, this.subtitle_sinhala, this.title, this.title_sinhala).subscribe(
      data => {
        this.serviceClass.getCategoryAllType().subscribe(
          data => {
            this.allCategories = data;
            this.showNotification("success","Category updated successfully!");
          }
        );
      }
    );
  }

  deleteCategory(id){
    if(confirm("Do you want to delete this?")) {
      this.serviceClass.deleteCategory(id).subscribe(
        data => {
          if(data) {
            this.serviceClass.getCategoryAllType().subscribe(
              data => {
                this.allCategories = data;
                this.cancelCategories();
                this.showNotification("success", "Category deleted successfully!");
              }
            );
          }
        }
      );
    }
  }
}
